// extracted by mini-css-extract-plugin
module.exports = {"menusContainer":"Menu_menusContainer__2GHjS","title":"Menu_title__XeCLE"};